import './styles.scss'

export default function About(props) {

  return (
    <div className='AboutContent'>
      <h1>About</h1>
      <p>
        Generous gifts from generations of members have enabled Save the Redwoods League to make extraordinary progress in our mission to protect and restore the redwood forest, and to connect people to the peace and beauty of the redwoods.
      </p>
      <p>
        Over the last century, the League has protected more than 216,000 acres of redwood forests and helped create 66 redwood parks and reserves. We have pioneered science-based forest-restoration work, and we have touched the lives of millions of people by connecting them to these wonders of nature.
      </p>
      <p>
        A grove dedication through Save the Redwoods League is a tribute that lasts as long as the redwoods. Your special gift to dedicate a redwood grove can honor or memorialize a loved one or yourself, while supporting the redwood forests across California that you care about. For more information about dedicating a redwood grove, please contact Jackie Perkins at 415-820-5847 or <a href="mailto:JPerkins@savetheredwoods.org">JPerkins@savetheredwoods.org</a>
      </p>
    </div>
  )
}
